import { Link, useTranslation } from "@refinedev/core";
import { FaHeartPulse, FaGear } from "react-icons/fa6";

export const WellnessBanner = () => {
    const { translate } = useTranslation();

    return (
        <div className="relative group overflow-hidden rounded-[2rem] shadow-sm border border-base-200/60 transition-all duration-500 hover:shadow-md h-full w-full flex flex-col">
            {/* Background: Solid Brand Secondary with subtle depth */}
            <div className="absolute inset-0 bg-secondary shadow-inner"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-accent/5 pointer-events-none"></div>

            {/* Shimmer Effect Wrapper */}
            <div className="relative p-6 sm:p-8 flex flex-1 items-center justify-between overflow-hidden animate-shimmer">
                <div className="z-10 max-w-[65%] space-y-4">
                    <div className="inline-flex items-center gap-1.5 pl-2 pr-3 py-1 rounded-full bg-accent/20 border border-accent/30 backdrop-blur-md text-[10px] font-bold uppercase tracking-wider text-accent-content/90">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-base-100 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-base-100"></span>
                        </span>
                        {translate("common.today")}
                    </div>

                    <h3 className="text-2xl sm:text-3xl font-black text-base-100 leading-tight transition-transform duration-500 group-hover:scale-[1.01]">
                        {translate("page.wellness-diagnosis.banner.title")}
                    </h3>

                    <p className="text-sm sm:text-base text-base-100/80 font-medium leading-relaxed max-w-md">
                        {translate("page.wellness-diagnosis.banner.description")}
                    </p>

                    <div className="pt-2">
                        <Link to="/wellness-diagnosis" className="no-underline">
                            <button className="group/btn relative inline-flex items-center justify-center px-8 py-3 font-bold text-secondary transition-all duration-300 bg-base-100 rounded-full hover:bg-white hover:shadow-xl hover:-translate-y-1 active:scale-95 overflow-hidden">
                                <span className="relative z-10 flex items-center gap-2">
                                    {translate("page.wellness-diagnosis.banner.button")}
                                    <FaGear className="w-4 h-4 transition-transform duration-500 group-hover/btn:rotate-90" />
                                </span>
                            </button>
                        </Link>
                    </div>
                </div>

                {/* Decorative Icon Elements */}
                <div className="absolute right-[-10%] bottom-[-10%] transition-all duration-700 group-hover:scale-110 group-hover:rotate-12 group-hover:-translate-x-4 opacity-10">
                    <FaHeartPulse className="w-64 h-64 fill-base-100" />
                </div>
                <div className="absolute right-10 top-10 w-32 h-32 bg-accent/10 rounded-full blur-3xl animate-pulse"></div>
            </div>
        </div>
    );
};
